'use client'

import UIContainer from '@components/ui/UIContainer'
import UIDivider from '@components/ui/UIDivider'
import UIFlex from '@components/ui/UIFlex'
import { Box } from '@mui/joy'
import { SxProps } from '@mui/joy/styles/types'
import { pxToRem } from '@ui/style/muiTheme'

type SplittedWrapperProps = {
	aside?: React.ReactNode
	children: React.ReactNode
	className?: string
	sx?: SxProps
}

const SplittedWrapper = ({ aside, children, className, sx }: SplittedWrapperProps) => {
	return (
		<UIContainer className={className} sx={sx}>
			<UIFlex
				className="splitted-wrapper"
				flexDirection={{ lg: 'row', md: 'column', sm: 'column' }}
				width="100%"
				pt={{ md: pxToRem(24), sm: pxToRem(20) }}
				mb={{ xl: pxToRem(84), md: pxToRem(64), sm: pxToRem(48) }}
				sx={{
					'&>*:not(:first-child)': {
						marginLeft: {
							lg: pxToRem(24),
						},
					},
				}}
			>
				<UIFlex mb={{ sm: pxToRem(48), md: pxToRem(64), lg: 0 }} minWidth="0" flexGrow={1}>
					<Box>{children}</Box>
				</UIFlex>
				<UIDivider
					orientation="vertical"
					sx={{ display: { md: 'block', sm: 'none' }, marginRight: { md: '-1px' } }}
				/>
				{aside && (
					<Box
						component="aside"
						display={{ lg: 'flex', md: 'block' }}
						sx={{ width: { xl: pxToRem(360), lg: pxToRem(240) }, flexShrink: 0 }}
						minWidth="0"
					>
						{aside}
					</Box>
				)}
			</UIFlex>
		</UIContainer>
	)
}

export default SplittedWrapper
